import { createRoot } from 'react-dom/client';

export const PROMOMSG = 
	document.getElementById('promoMsg') && 
	createRoot(document.getElementById('promoMsg'))